module.exports = "<div class=\"col-sm-10 col-md-10 main\">\n  <h1 class=\"page-header\" style=\"margin-top:30px\">Account Funding Status</h1>\n  <div id=\"jqxExposureGrid\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/pages/exposure/acc-exp-fund/acc-exp-fund.component.html
// module id = ../../../../../src/app/pages/exposure/acc-exp-fund/acc-exp-fund.component.html
// module chunks = main